type Subscription = {
  unsubscribe(): void;
}
type Fn<T> = (value: T) => void;
type ErrFn = (err: any) => void;
type CompleteFn = () => void;
type Callback<T> = {
  fn: Fn<T>;
  errFn?: ErrFn;
  completeFn?: CompleteFn;
};

export class SimpleSubject<T> {
  _value: T | undefined = undefined
  cbs: Callback<T>[] = []

  _isDone = false

  constructor(value?: T) {
    if (value !== undefined) {
      this.next(value);
    }
  }

  next(value: T) {
    if (this._isDone) {
      throw new Error('can\'t emit value after subject done');
    }
    this._value = value;
    const cbs = this.cbs.map((c) => c);
    cbs.forEach((c) => {
      c.fn(value);
    });
  }

  subscribe(fn: Fn<T>, errFn?: ErrFn, completeFn?: CompleteFn) {
    const item = {fn, errFn, completeFn};
    this.cbs.push(item);
    const _this = this;
    return {
      unsubscribe() {
        _this.cbs.splice(_this.cbs.indexOf(item), 1);
      }
    };
  }

  complete() {
    if (this._isDone) {
      throw new Error('can\'t complete after subject done');
    }
    this._isDone = true;
    this.cbs.forEach((c) => {
      c.completeFn && c.completeFn();
    });
  }

  error(err: any) {
    if (this._isDone) {
      throw new Error('can\'t throw error after subject done');
    }
    this._isDone = true;
    this.cbs.forEach((c) => {
      c.errFn && c.errFn(err);
    });
  }
}
